import { camelize } from 'humps'

import type { Variant, Props } from '.'

export interface Raw {
  acfFcLayout: 'button'
  button: {
    children: string
    url: string
    variant: Variant
  }
}

export interface Parsed {
  name: 'Button'
  props: Props
}

export function parser(rawComponent: Raw): Parsed {
  const { variant, ...props } = rawComponent.button

  return {
    name: 'Button',
    props: {
      variant: camelize(variant) as Variant,
      ...props,
    },
  }
}
